"use client";

import { useEffect } from "react";
import { ErrorPageContent } from "@components/errors/ErrorPageContent";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";
import { Button } from "@ecco/ui/button";
import { Box } from "@ecco/ui/box";
import type { ReactElement } from "react";

export default function ErrorPage({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}): ReactElement {
    useEffect(() => {
        Logger.error(ServiceType.WEB, "Site error page", {
            tag: LogTag.ERROR,
            error,
        });
    }, [error]);

    return (
        <Box role="alert" pb={8}>
            <ErrorPageContent />
            <Box textAlign="center">
                <Button type="button" onClick={reset}>
                    Try again
                </Button>
            </Box>
        </Box>
    );
}
